import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import CorrRowColTable from '../../corrCluster/Correspondence/CorrRowColTable';
import ClusterSegmentComparisonTable from '../../corrCluster/Cluster/ClusterSegmentComparisonTable';

const GenericDHTCellContent = ({
  rowData,
  index,
  isCorrTable,
  isClusterSegTable,
}) => {
  return (
    <Fragment>
      {isCorrTable &&
        <CorrRowColTable
          data-test="genericDHTCellContentCompponent"
          rowData={rowData}
          index={index}
        />
      }
      {isClusterSegTable &&
        <ClusterSegmentComparisonTable
          rowData={rowData}
        />}
    </Fragment>
  );
};

GenericDHTCellContent.propTypes = {
  rowData: PropTypes.instanceOf(Object),
  index: PropTypes.number,
  isCorrTable: PropTypes.bool,
  isClusterSegTable: PropTypes.bool,
};

export default GenericDHTCellContent;
